import { gql } from '@apollo/client'

const GET_GOOGLE_PLACES = gql`
  query GET_GOOGLE_PLACES($searchTerm: String!, $country: String!, $companyId: ID) {
    getGooglePlaces(searchTerm: $searchTerm, country: $country, companyId: $companyId)
  }
`

export default GET_GOOGLE_PLACES
